<template>
  <BaseContainerSpread>
    <UiPageHeader
      :title="dapLangGlobal.csearch"
      :description="{
        ja: 'テーマ別検索では、特定のトピックやデータベースに特化した検索項目で検索ができます。',
        en: 'Designed searches have detailed search conditions for specific topics or databases.',
      }"
      icon="koicon/koicon-42"
    />
  </BaseContainerSpread>
  <BaseContainerSpread
    class="jps-list-card-layout page-csearch-body"
    tag="section"
    v-if="ss.searched"
    :id="ss.state.storeId"
  >
    <div class="search-result-header">
      <div class="is-size-7-touch">
        <p>{{ lst(dapLangGlobal.numFound, num(ss.state.result?.hit)) }}</p>
      </div>
      <SearchPagination class="pagenation" :ss="ss" />
      <div class="narrow-search">
        <SearchBoxSimple :ss="ss" :auto="true" />
      </div>
    </div>
    <Transition name="cs-item">
      <BaseLayoutGrid>
        <div v-for="cs in ss.state.result.list" :key="cs.id" class="grid-item">
          <UiDataCard class="is-dark" type="csearch" :data="cs" />
        </div>
      </BaseLayoutGrid>
    </Transition>
    <SearchPagination
      class="footer-paginaition"
      :ss="ss"
      autoscroll
    />
  </BaseContainerSpread>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

definePageMeta({
  disableDefaultMargin: {
    bottom: true,
  },
  qsearch: true,
})
const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const { lst, num } = useI18n()
const { searchCustomSearch } = useCustomSearch()
const ss = useSearch<CustomSearchDefinition>(
  {
    keywordFields: ['keywords'],
    keywordPlaceholder: { ja: '絞り込み', en: 'Filter' },
  },
  searchCustomSearch,
  {
    queryRewriter: (q: SearchQuery) => {
      q.permission = 'P'
      if (!q.query) q.query = {}
      q.query.type = ['NORMAL']
      return q
    },
  },
)
await ss.restoreQuery()
</script>

<style lang="scss" scoped>
.page-csearch-body {
    background-color: #fafafa;
}
.grid-item {
  .jps-card {
    height: 400px;
  }
}
.pagenation {
  flex-grow: 1;
}
</style>
